module.exports = __webpack_public_path__ + "static/media/planet-ringed.a31c3d40.svg";